module.exports = __webpack_public_path__ + "img/banner.87528071.jpg";